module.exports = __webpack_public_path__ + "static/travelzik1bw-b355a98768f0ab951b40c3df48514b39.jpg";